import { useEffect, useState } from 'react'
import { DebounceInput } from 'react-debounce-input'
import { useIntl } from 'react-intl'

import * as Component from 'src/feature/bite/component'
import MemberList from '../component/List'
import FilterDrawer from '../component/List/FilterDrawer'

import { useGetList } from '../context/useQuery'
import { useMember } from '../hook'

import Export from '../component/List/Export'

export default function Members() {
  const intl = useIntl()
  const { listFilter, listFilterSet } = useMember()
  const { isLoading, isFetching } = useGetList()
  const [search, setSearch] = useState('')
  const [open, setOpen] = useState(false)
  const [badges, setBadges] = useState<{ key: string; value: string }[]>([{ key: 'search', value: '' }])
  const tableName = 'members'

  useEffect(() => {
    if (listFilter.filterList.length > 0) {
      const searchFilter = listFilter.filterList.find((x) => x.key === 'fllNm')

      if (searchFilter) {
        setSearch(searchFilter.value[0])
        setBadges([{ key: 'search', value: searchFilter.value[0] }])
      }
    }
  }, [])

  return (
    <>
      <Component.Breadcrumb currentPage={intl.formatMessage({ id: 'MEMBER_PLURAL' })} />
      <div>
        <h3 className='text-dark fw-bolder mt-10 mb-2'>
          {intl.formatMessage({ id: 'MEMBER_PLURAL.LIST' })}
        </h3>
        <p className='text-muted fs-6'>
          {intl.formatMessage({ id: 'MEMBER_PLURAL.LIST.DESC' })}
        </p>
      </div>
      <div className='card mt-10'>
        <div className='card-header border-0 pt-6'>
          <div className='card-title'>
            <div className='d-flex align-items-center position-relative my-1'>
              <i className='ki-outline ki-magnifier fs-3 position-absolute ms-5'></i>
              <DebounceInput
                debounceTimeout={500}
                type='text'
                className='form-control form-control-solid w-600px ps-13'
                placeholder={intl.formatMessage({ id: 'MEMBER.FILTER.SEARCH' })}
                value={search}
                onChange={(e) => {
                  setSearch(e.target.value)
                  listFilterSet({
                    ...listFilter,
                    paging: {
                      ...listFilter.paging,
                      currentPageNumber: 1,
                    },
                    filterList: [
                      {
                        key: 'fllNm',
                        operator: 14,
                        logicalOp: 2,
                        value: [e.target.value],
                        childFilters: [
                          {
                            key: 'emlAddrss',
                            operator: 14,
                            logicalOp: 2,
                            value: [e.target.value],
                            childFilters: [],
                          },
                          {
                            key: 'mblPhn',
                            operator: 14,
                            logicalOp: 2,
                            value: [e.target.value],
                            childFilters: [],
                          },
                          {
                            key: 'mmbrNo',
                            operator: 14,
                            logicalOp: 2,
                            value: [e.target.value],
                            childFilters: [],
                          }
                        ],
                      },
                    ],
                  })

                  let newBadges = [...badges]
                  newBadges[0] = { key: 'search', value: e.target.value }

                  setBadges(newBadges)

                  // if (e.target.value === '') {
                  //   setBadges(badges.filter((x: any) => x.key !== 'search'));
                  // } else {
                  //   let badge = badges.find((x: any) => x.key === 'search');

                  //   if (badge) {
                  //     badge.value = e.target.value;
                  //   } else {
                  //     setBadges([...badges, { key: 'search', value: e.target.value }]);
                  //   }

                  //   setBadges([...badges]);
                  // }
                }}
              />

              {/* <div style={{ marginLeft: 16 }}>
                {badges.length > 0 && (
                  <>
                    {badges.map((item: any, index: number) => {
                      let filterName = ''

                      if (item.value === '') return null

                      switch (item.key) {
                        case 'search':
                          filterName = intl.formatMessage({ id: 'GLOBAL.FILTER.SEARCH' })
                          break
                        case 'startDate':
                          filterName = intl.formatMessage({ id: 'GLOBAL.FILTER.START_DATE' })
                          break
                        case 'endDate':
                          filterName = intl.formatMessage({ id: 'GLOBAL.FILTER.END_DATE' })
                          break
                        default:
                          break
                      }

                      return (
                        <span className='badge badge-success mr-2' key={index}>
                          {filterName}: {item.value}
                        </span>
                      )
                    })}
                  </>
                )}
              </div> */}
            </div>
          </div>
          <div className='card-toolbar'>
            <div className='d-flex justify-content-end' data-kt-customer-table-toolbar='base'>
              <div className='d-flex align-items-center gap-2 gap-lg-3'>
                <button
                  onClick={() => setOpen(!open)}
                  className='btn btn-light'
                  data-bs-toggle='tooltip'
                  data-bs-placement='left'
                  data-bs-dismiss='click'
                  data-bs-trigger='hover'
                  id='kt_filter_toggle'
                >
                  <i className='bi bi-sliders fs-4 me-4'></i>
                  {intl.formatMessage({ id: 'GLOBAL.FILTER' })}
                </button>
                <FilterDrawer
                  open={open}
                  setOpen={setOpen}
                  search={search}
                  setSearch={setSearch}
                  setFilter={(value: any) => {
                    listFilterSet({
                      ...listFilter,
                      filterList: value,
                      paging: {
                        ...listFilter.paging,
                        currentPageNumber: 1,
                      },
                    })
                  }}
                  badges={badges}
                  setBadges={setBadges}
                />

                <Export tableName={tableName} />
              </div>
            </div>
          </div>
        </div>
        <div className='card-body pt-10'>
          <MemberList loading={isLoading || isFetching} />
        </div>
      </div>
    </>
  )
}
